import React, { useState } from 'react';
interface CurrencyFieldProps {
  id: string;
  label: string;
  value: number;
  onChange: (value: number) => void;
  readOnly?: boolean;
  changed?: boolean;
  helperText?: string;
  hideLabel?: boolean;
}
function formatDisplay(value: number): string {
  if (!Number.isFinite(value)) return '0.00';
  return value.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
}
export function CurrencyField({
  id,
  label,
  value,
  onChange,
  readOnly = false,
  changed = false,
  helperText,
  hideLabel = false
}: CurrencyFieldProps) {
  const [draft, setDraft] = useState<string | null>(null);
  const display = draft === null ? formatDisplay(value) : draft;
  const handleChange = (raw: string) => {
    const cleaned = raw.replace(/[^0-9.]/g, '');
    setDraft(cleaned);
    const parsed = Number.parseFloat(cleaned);
    onChange(Number.isFinite(parsed) ? parsed : 0);
  };
  return <div className="flex flex-col" data-id="element-1" data-mp="2w2kl6kyst1hb">
      <label htmlFor={id} className={hideLabel ? 'sr-only' : 'mb-1.5 text-[11px] font-semibold uppercase tracking-wide text-slate-500'} data-id="element-2" data-mp="3d4qp1y6ocwz5">
        {label}
      </label>
      <div className="relative" data-id="element-3" data-mp="343affsnooyvz">
        <span aria-hidden="true" className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-sm text-slate-400" data-id="element-4" data-mp="344c1sta5h7t0">
          $
        </span>
        <input id={id} type="text" inputMode="decimal" readOnly={readOnly} value={display} onFocus={() => setDraft(value ? String(value) : '')} onBlur={() => setDraft(null)} onChange={event => handleChange(event.target.value)} className={['w-full rounded border bg-white py-2 pl-7 pr-3 text-sm tabular-nums text-slate-900 shadow-sm outline-none transition', 'focus:border-[#0176d3] focus:ring-2 focus:ring-[#0176d3]/30', readOnly ? 'cursor-default bg-slate-50 text-slate-600' : '', changed ? 'border-amber-400 bg-amber-50' : 'border-slate-300'].join(' ')} data-id="element-5" data-mp="3vtyft2hja08l" />
      </div>
      {helperText ? <p className="mt-1 text-[11px] text-slate-500" data-id="element-6" data-mp="or1j52nfia42">{helperText}</p> : null}
    </div>;
}